<!--  -->
<template>
  <div class='xuexi round bj-col-white pad' v-loading="loading">
    <header>
      <main class="nav">
        <div class="heard">
          <h3>公需课程<span>(学习)</span></h3>
        </div>
        <div class="year">
          <span>选择年份</span>
          <el-select v-model="year" placeholder="请选择" @change="changeYear">
            <el-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </main>
      <main v-if="year == 2026">
        <div class="heard">
          <h3>公需课程<span>(考试)</span></h3>
        </div>
        <div class="btn">
          <el-button type="warning" @click="handleLianxi">模拟练习</el-button>
          <el-button type="info" v-if="info.nover != 0" @click="handleTs">正式考试</el-button>
          <template v-else>
            <el-button type="danger" v-if="info.ks_state != 2" @click="handleKaoshi">正式考试</el-button>
            <el-button type="success" v-else @click="handleTs">正式考试</el-button>
          </template>
        </div>
      </main>
      <div class="code">
        <img src="../../assets/img/code/study-h5.png" alt="">
        <span>手机学习请扫公众号二维码</span>
      </div>
    </header>
    <p>公需课程：30学时，计10学分。</p>

    <template>
      <div class="table">
        <div @click="handleTable(0)">
          <h4 :style="{color: type == 0 ? '#06B487' : ''}">{{info.all || 0}}</h4>
          <div :style="{color: type == 0 ? '#06B487' : ''}">全部课程</div>
        </div>
        <div @click="handleTable(1)">
          <h4 :style="{color: type == 1 ? '#06B487' : ''}">{{info.over || 0}}</h4>
          <div :style="{color: type == 1 ? '#06B487' : ''}">已完成</div>
        </div>
        <div @click="handleTable(2)">
          <h4 :style="{color: type == 2 ? '#FF0000' : '#FF0000'}">{{info.nover || 0}}</h4>
          <div :style="{color: type == 2 ? '#FF0000' : '#FF0000'}">未完成</div>
        </div>
        <div v-if="year == 2026">
          <h4 :style="{color: info.nover != 0 ? '' : info.ks_state !=2 ? '#FF0000' : '#67C23A'}">考试</h4>
          <div :style="{color: info.nover != 0 ? '' : info.ks_state != 2 ? '#FF0000' : '#67C23A'}">
            {{ info.ks_state == 2 ? '合格' : '未完成' }}
          </div>
        </div>
      </div>
      
      <div class="list">
        <kc-array :list="list" :year="Number(year)"></kc-array>
      </div>
    </template>

    <el-dialog
      :visible.sync="show"
      width="30%"
      top="15vh"
      :close-on-click-modal="false"
      :show-close="true"
      center
      append-to-body>
      <template slot="title">
        <div style="color: #4CC08C;font-size: 20px;font-weight: bolder;">公需考试</div>
      </template>
      <div class="hint">
        <template v-if="info.nover != 0">
          <p style="line-height: 2.5;font-weight: bold;text-indent: 33px;">温馨提醒：公需课<span>边学边弹题</span>。26年开始，<span>学完</span>后还需<span>参加“正式考试”</span>，60分合格，<span>获取10学分</span>。</p>
          <p style="line-height: 2.5;font-weight: bold;text-indent: 33px;"><span style="background-color: yellow;">学习及考试截止至 2027 年 4 月 30 日，逾期系统自动关闭通道，将无法取得继续教育学时证明。</span></p>
        </template>
        <template v-else-if="info.ks_state != 2">
          <p>您尚未完成公需考试，请尽快参加<span>“公需正式考试”</span>，60分合格，获取<span>10</span>学分。</p>
        </template>
      </div>
      <span slot="footer">
        <el-button round type="success" class="self-button--success" size="medium" style="width: 160px" @click="show = false">我知道了</el-button>
        <el-button round type="primary" class="self-button--primary" size="medium" style="width: 160px" @click="handleKaoshi" v-if="info.nover == 0 && info.ks_state != 2">进入考试</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from '../../api/gongxu'
import KcArray from '../components/KcArray.vue'

export default {
  components: {
    KcArray,
  },
  data() {
    return {
      year: '',
      year_copy: '',
      options: [],
      type: 0,
      info: {},
      list: [],
      loading: true,
      show: false,
    };
  },
  computed: {},
  watch: {
    
  },
  created() {
    
  },
  mounted() {
    this.getYears()
  },
  //方法集合
  methods: {
    getYears () {
      Api.getYears().then(res => {
        if (res.data.code == 1) {
          this.options =  res.data.data.years
          this.year = res.data.data.year
          this.year_copy = this.year
          this.getStatus()
        } else {
          this.$message.error('公需科目年份目录获取失败')
        }
      })
    },
    changeYear () {
      localStorage.setItem("year", this.year)
      Api.setYears({
        year: this.year
      }).then(res => {
        if (res.data.code == 1) {
          this.year_copy = this.year
          this.setUserInfo()
          this.getStatus()
        } else {
          this.year = this.year_copy
          this.$message.error("公需科目年份切换失败")
        }
      })
    },
    getStatus () {
      if (this.year == 2020) {
        this.$alert('2020年公需科目无课程学习，广东省执业药师注册从2021年开始提供公需科目。', '温馨提示', {
          confirmButtonText: '确认',
          callback: () => {
            this.$emit('noAuth')
          }
        });
        return;
      }
      if (this.year < 2026) {
        this.$confirm('<div style="text-indent: 32px;text-align:left">按省药监局统一要求：1、公需课程<span style="color: red">严禁</span>倍速播放学习；2、<span style="color: red">严禁多浏览器</span>或<span style="color: red">技术手段同时</span>在线<span style="color: red">刷课</span>。省局审核判定 “<span style="color: red">作弊</span>”，所有课程<span style="color: red">全部清除重学</span>。</div>', '重要提示', {
          dangerouslyUseHTMLString: true,
          center: true,
          showCancelButton: false,
          confirmButtonText: '知道了',
        })
      }
      Api.getStatus({
        year: this.year
      }).then(res => {
        if (res.data.code == 1) {
          this.type = 0
          this.info = res.data.data
          // this.info.nover = 1
          // this.info.nover = 0
          // this.info.ks_state = 0
          // this.info.ks_state = 1
          // this.info.ks_state = 2
          let gx_to = window.localStorage.getItem('gx_to') || 1
          window.localStorage.setItem('gx_to', 1)
          if (this.year == 2026 && gx_to == 1) {
            if (this.info.nover != 0) {
              this.show = true
            } else if (this.info.ks_state != 2) {
              this.show = true
            }
          }
          this.getCourseList()
        } else {
          this.$message.error('课程学习进度获取失败')
        }
      })
    },
    handleLianxi () {
      window.localStorage.setItem('gx_zy', 2)
      window.localStorage.setItem('gx_to', 2)
      this.$router.push('/gongxu/lianxi')
    },
    handleKaoshi () {
      window.localStorage.setItem('gx_zy', 2)
      window.localStorage.setItem('gx_to', 2)
      this.$router.push('/gongxu/kaoshi')
    },
    handleTs () {
      if (this.info.nover != 0) {
        this.$confirm('请学完课程后，再进入考试。', '温馨提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'info',
          center: true
        })
      } else {
        this.$confirm(`<p>考试已合格，请到“广东省执业药师管理系统”<br/>查询公需10学分。</p>`, '温馨提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          type: 'success',
          center: true
        })
      }
    },
    handleTable (type) {
      this.type = type
      this.getCourseList()
    },
    getCourseList () {
      Api.getCourseList({
        year: this.year,
        type: this.type
      }).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.list = res.data.data
          if (res.data.data.length < 1) {
            this.$router.replace({name: 'Maike'})
          }
        } else {
          this.$message.error("公需科目课程列表获取失败")
        }
      })
    },
  },
}
</script>

<style lang='less' scoped>
.xuexi {
  padding: 0 40px !important;
  > header {
    display: flex;
    justify-content: space-between;
    gap: 0 20px;
    > main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;
      min-width: 30%;
      border-right: 1px solid #D8D8D8;
      padding-right: 20px;
      flex: 1;
      .heard {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          font-size: 18px;
        }
        span {
          font-size: 16px;
          display: inline-block;
          margin-left: 5px;
        }
      }
      .year {
        display: flex;
        align-items: center;
        > span {
          color: #000;
          margin-right: 15px;
          font-weight: bold;
        }
        > div {
          width: 120px;
        }
      }
    }
    > .code {
      padding: 20px 0 20px 0px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      img {
        width: 120px;
      }
    }
  }
  > p {
    margin-bottom: 20px;
  }
  .table {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    background-color: #EDF6FF;
    padding: 15px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      > div {
        color: #999999;
        margin-top: 10px;
      }
    }
  }
  .list {
    width: 100%;
    margin: 20px 0;
  }
}

.hint {
  > p {
    > span {
      color: red;
    }
  }
}
</style>